import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import { VIEWS } from '../constant/ViewConstant';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const BreadCrumb = () => {
    const navigate = useNavigate();
    const locations = useLocation().pathname.split('/');
    const breadCrumbMenus = [];
    var map = VIEWS.views;
    locations.forEach((location, key) => {
        if (key > 0 && map != null) {
            var menu = map.get(location);
            if (menu != null) {
                breadCrumbMenus.push(menu);
                map = menu.views;
            }
        }
    });

    const handleClick = (e, path) => {
        e.preventDefault();
        navigate(path);
    };

    return (
        <Breadcrumbs separator={<NavigateNextIcon fontSize='small' />}>
            <Link key={9999} color='inherit' href='#' onClick={(e) => handleClick(e, '/')}>
                <div className='breadcrumb-text'>HOME</div>
            </Link>
            {breadCrumbMenus.map((menu, key, array) =>
                key < array.length - 1 ? (
                    <Link key={key} color='inherit' onClick={(e) => handleClick(e, menu.path)}>
                        <div className='breadcrumb-text'>{menu.title}</div>
                    </Link>
                ) : (
                    <Typography key={999} color='primary'>
                        {menu.title}
                    </Typography>
                )
            )}
        </Breadcrumbs>
    );
};

export default BreadCrumb;
